module.exports = __webpack_public_path__ + "static/media/Confrimar.7aee64a9.svg";